import React, { useState } from 'react'
import './Home.css'
import Header from '../../Component/Navbar/Header/Header'
import ExploreMenu from '../../Component/ExploreMenu/ExploreMenu'
import FoodDisplay from '../../Component/FoodDisply/FoodDisplay'
import AppDownload from '../../Component/AppDownload/AppDownload'
const Home = () => {
    const [category,setcategory]=useState("All")
  return (
    <>
        <Header/>
        <ExploreMenu category={category} setcategory={setcategory}/>
        <FoodDisplay category={category}/>
        <AppDownload/>
    </>
  )
}

export default Home
